<i18n
  src="@/locales/components/views/agro_exporter/production/query_container_export/exportation_details.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/exportation.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<template>
  <a :class="['link', link_color]" @click.prevent="open = true"
    ><i :class="icon" /><span class="space-icon" />
    <template v-if="display_container_code">{{
      container.container_code
    }}</template></a
  >
  <TransitionRoot as="template" :show="open">
    <Dialog
      as="div"
      class="fixed z-10 inset-0 overflow-y-auto"
      @close="open = false"
    >
      <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="ease-in duration-200"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <DialogOverlay
            class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          />
        </TransitionChild>

        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
          >&#8203;</span
        >
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to="opacity-100 translate-y-0 sm:scale-100"
          leave="ease-in duration-200"
          leave-from="opacity-100 translate-y-0 sm:scale-100"
          leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div class="panel-modal">
            <div class="panel-modal-close">
              <button
                type="button"
                class="panel-modal-close"
                @click="open = false"
              >
                <span class="sr-only">Close</span>
                <i class="h-6 w-6 fa-solid fa-xmark"></i>
              </button>
            </div>

            <div class="panel-header-title">
              {{ $t("model.container.container_code") }}
              {{ container.container_code }}
            </div>

            <div class="panel-modal-body">
              <div class="grid grid-cols-2 gap-x-4 gap-y-8">
                <div class="sm:col-span-1">
                  <dt class="label-data">
                    {{ $t("model.container.week") }}
                  </dt>
                  <dd class="content-data">
                    {{ container.week }}
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="label-data">
                    {{ $t("model.exportation.status") }}
                  </dt>
                  <dd class="content-data">
                    <container-status :status_id="container.status_id" />
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="label-data">
                    {{ $t("model.container.customer") }}
                  </dt>
                  <dd class="content-data">
                    {{ container.customer?.name }}
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="label-data">
                    <template v-if="container.exportation">
                      <template
                        v-if="container.exportation.exportation_type_id == 0"
                      >
                        {{ $t("model.exportation.booking_code_0") }}
                      </template>
                      <template
                        v-else-if="
                          container.exportation.exportation_type_id == 1
                        "
                      >
                        {{ $t("model.exportation.booking_code_1") }}
                      </template>
                    </template>
                  </dt>
                  <dd class="content-data">
                    {{ container.exportation?.booking_code }}
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="label-data">
                    {{ $t("model.container.packing_house") }}
                  </dt>
                  <dd class="content-data" v-html="packing_house">
                  </dd>
                </div>
                <div class="sm:col-span-1" v-if="provider">
                  <dt class="label-data">
                    {{ $t("model.container.provider") }}
                  </dt>
                  <dd class="content-data" v-html="provider">
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="label-data">
                    {{ $t("model.container.load_date") }}
                  </dt>
                  <dd class="content-data">
                    {{ dateFormatter(container.load_date) }}
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="label-data">
                    {{ $t("model.container.waybill") }}
                  </dt>
                  <dd class="content-data">
                    {{ container.waybill }}
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <template v-if="container.brand_name">
                    <dt class="label-data">
                      {{ $t("model.container.exporter_process_brand") }}
                    </dt>
                    <dd class="content-data">
                      {{ container.brand_name }}
                    </dd>
                  </template>
                </div>
                <div class="sm:col-span-1">
                  <dt class="label-data">
                    {{ $t("model.container.rows_package_groups") }}
                  </dt>
                  <dd class="content-data">
                    {{ container.rows_package_groups }}
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="label-data">
                    {{ $t("model.container.cols_package_groups") }}
                  </dt>
                  <dd class="content-data">
                    {{ container.cols_package_groups }}
                  </dd>
                </div>
                <div class="sm:col-span-2">
                  <dt class="label-data">
                    {{ $t("model.container.private_comments") }}
                    <em
                      class="text-sm text-green-800 bg-green-100 p-1 rounded-md"
                    >
                      {{ $t("model.container.describe_private_comments") }}
                    </em>
                  </dt>
                  <dd class="content-data">
                    {{ container.private_comments }}
                  </dd>
                </div>
                <div class="sm:col-span-2">
                  <dt class="label-data">
                    {{ $t("model.container.comments") }}
                    <em class="text-sm text-red-800 bg-red-100 p-1 rounded-md">
                      {{ $t("model.container.describe_comments") }}
                    </em>
                  </dt>
                  <dd class="content-data">
                    {{ container.comments }}
                  </dd>
                </div>
              </div>
            </div>

            <div class="panel-modal-footer">
              <button
                type="button"
                class="panel-modal-footer-close"
                @click="open = false"
              >
                Cerrar
              </button>
            </div>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import ContainerStatus from "@/components/views/agro_exporter/production/shared/container/ContainerStatus.vue";

import { ref, computed } from "vue";
import {
  Dialog,
  DialogOverlay,
  TransitionChild,
  TransitionRoot
} from "@headlessui/vue";

export default {
  name: "AEProductionQueryContainerExportExportationDetails",
  components: {
    ContainerStatus,
    Dialog,
    DialogOverlay,
    TransitionChild,
    TransitionRoot
  },
  props: ["container", "icon", "link_color", "display_container_code"],
  setup(props) {
    const open = ref(false);
    const provider = computed(() => {
      return props.container.provider_names.join("<br />");
    });

    const packing_house = computed(() => {
      return props.container.packing_house_names.join("<br />");
    });

    return {
      open,
      provider,
      packing_house
    };
  }
};
</script>
